import React, { useMemo } from 'react'
import { usePagination } from '../../../hooks'
import {
  TextField,
  Datagrid,
  ArrayField,
  FunctionField,
  useQuery,
  ListContextProvider,
  Pagination,
} from 'react-admin'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import keyBy from 'lodash/keyBy'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { formatMatchStatus } from '../../utils/format'
import CategoryName from '../../../components/custom/CategoryName'
import { Typography } from '@material-ui/core'

export const Brackets = (props) => {
  const currentTourId = useMemo(() => {
    return props.id
  }, [props])

  const { page, perPage, setPage, setPerPage } = usePagination()
  const { data, total } = useQuery({
    type: 'getList',
    resource: 'brackets/',
    payload: {
      pagination: { page, perPage },
      sort: { field: 'id', order: 'ASC' },
      filter: { 'category.tournament': currentTourId },
    },
  })
  const getParticipantName = (participant) => {
    if (participant?.user) return participant.user.fullName
    return 'Нет соперника'
  }

  return (
    <>
      <Typography variant='h5' paragraph>
        Категории
      </Typography>
      <ListContextProvider
        value={{
          resource: 'brackets',
          data: keyBy(data, 'id'),
          ids: data?.map((el) => el.id),
          currentSort: { field: 'id', order: 'ASC' },
          selectedIds: [],
        }}
      >
        <Datagrid>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <FunctionField
                label='Сетка'
                render={(record) => <CategoryName category={record.category} />}
              />
            </AccordionSummary>
            <AccordionDetails>
              <ArrayField source='matches' fieldKey='id'>
                <Datagrid>
                  <TextField source='locationIndex' label='Индекс матча' />
                  <FunctionField
                    label='Участник 1'
                    render={(record) =>
                      getParticipantName(record.participantOne)
                    }
                  />
                  <FunctionField
                    label='Участник 2'
                    render={(record) =>
                      getParticipantName(record.participantTwo)
                    }
                  />
                  <FunctionField
                    label='Статус матча'
                    render={(record) => formatMatchStatus(record.status)}
                  />
                </Datagrid>
              </ArrayField>
            </AccordionDetails>
          </Accordion>
        </Datagrid>
        <Pagination
          page={page}
          perPage={perPage}
          setPage={setPage}
          total={total}
          setPerPage={setPerPage}
        />
      </ListContextProvider>
    </>
  )
}
